<template>
  <p style="display: flex; flex-direction: column; justify-content: start; align-items: start;">
    <label class="btn btn-default btn-file" v-if="!disabled">
      <i class="fas fa-upload mr10"></i>
      <input type="file" style="display: none;" @change="fileChangeHandler($event)" />
      <span class="all-column">{{
        nameDisplay() ? nameDisplay() : 'Upload File'
      }}</span>
    </label>
    <label class="btn btn-default btn-file" v-else @click="downloadFile(list.form_sub_value)">
      <i class="fas fa-download mr10"></i>
      <span class="all-column">{{
        nameDisplay() ? nameDisplay() : 'Download File'
      }}</span>
    </label>
  </p>
</template>
<script>
import axios from 'axios'
import { api_lp } from '../../services/config'
export default {
  props: ['step', 'i', 'list', 'disabled'],
  data() {
    return {
      is_uploading: false,
      original_file_name: "",
    }
  },
  methods: {
    getOriginalFileName(filepath) {
      if (filepath) {
        let split = filepath.split('/')
        return split[split.length - 1]
      }

      return false
    },
    nameDisplay() {
      if (this.original_file_name || this.list.form_sub_value) {
        if (this.is_uploading) {
          return this.original_file_name
        } else {
          return this.getOriginalFileName(this.list.form_sub_value)
        }
      } else {
        return false
      }
    },
    fileChangeHandler(e) {
      let fileUpload = Array.from(e.target.files)
      let fileType = fileUpload[0].type
      let fileName = fileUpload[0].name

      fileUpload['file'] = fileUpload
      fileUpload['fileName'] = fileUpload[0].name

      if (
        fileType.search(/jpeg|jpg|pdf|xls|zip|rar/gi) >= 0 ||
        fileName.search(/.rar/gi) >= 0
      ) {
        this.uploadFile(fileUpload[0])
      } else {
        alert(`Jenis File ${fileType} tidak dapat di upload`)
      }
    },
    async uploadFile(file) {
      try {
        await this.$store.commit('modalStore/SET_GLOBAL_LOADING', true)

        const url = `${api_lp}/api/v1/vendor/vendor-additional-document`

        let request_id = this.$get(this.$store, 'state.landingpage.request_id', null)
        if (!request_id) throw new Error('Request ID not found')
        let bodyFormData = new FormData()

        bodyFormData.append('request_id', request_id)
        bodyFormData.append('md_landing_form_id', this.list.id)
        bodyFormData.append('md_landing_step_id', this.list.md_landing_step_id)
        bodyFormData.append('question_type', this.list.question_type)
        bodyFormData.append('name', this.list.name)
        bodyFormData.append('is_active', this.list.is_active)
        bodyFormData.append('is_mandatory', this.list.is_mandatory)
        bodyFormData.append('vendor_id', this.$get(this.$store, 'state.landingpage.vendor_id', 0))
        bodyFormData.append('text', this.list.text)
        bodyFormData.append('vendor_document[]', file)

        const { data } = await axios({
          method: 'POST',
          url,
          data: bodyFormData,
          headers: { 'Content-Type': 'multipart/form-data' },
        })

        if (data && data.status == 'success' && data.data) {
          let result = data.data
          await this.$store.commit('landingpage/MD_STEP_UPDATE', {
            step: this.step,
            name: 'form_value',
            value: result.form_value,
            index: this.i + 2
          })
          await this.$store.commit('landingpage/MD_STEP_UPDATE', {
            step: this.step,
            name: 'form_sub_value',
            value: result.form_sub_value,
            index: this.i + 2
          })

          this.is_uploading = false
          this.original_file_name = this.getOriginalFileName(result.form_sub_value)
          await this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
        }
      } catch (error) {
        await this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
      }
    },
    async downloadFile(link) {
      if (link) {
        let linkUrl = `${api_lp}/vendor-add-doc/${link}`
        console.log('linkUrl', linkUrl)
        await this.$store.commit('modalStore/SET_GLOBAL_LOADING', true)
        await axios({
          url: linkUrl,
          method: 'GET',
          responseType: 'blob',
        })
          .then(async response => {
            let fileURL = window.URL.createObjectURL(new Blob([response.data]))
            let fileLink = document.createElement('a')

            fileLink.href = fileURL
            fileLink.setAttribute('download', this.$linkConverter(link))
            document.body.appendChild(fileLink)

            fileLink.click()

            await this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
          })
          .catch(async error => {
            await this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
          })
      }
    },
  },
}
</script>
